"use client";
// Imports
import { toast } from "sonner";
import usePersistStore from "@/lib/usePersistStore";
import { useMyShowStore } from "@/lib/persistState";
import { PiHeartBold, PiHeartFill } from "react-icons/pi";
import { Img, Placeholder } from "@/components";
import useStore from "@/lib/state";

// Add to My Show Button
export function AddToMyShowButton({
  userId,
  slug,
  image,
  title,
  type = "showbags",
}) {
  const myShowStore = usePersistStore(useMyShowStore, (state) => state);
  const { isMyShowOpen, setIsMyShowOpen } = useStore();

  if (!myShowStore) return <PiHeartBold size={30} />;

  // Variables
  const {
    myShowbags,
    addShowbag,
    removeShowbag,
    myRides,
    addRide,
    removeRide,
    myEvents,
    addEvent,
    removeEvent,
    myFood,
    addFood,
    removeFood,
  } = myShowStore;

  // Check if the item exists in My Show
  let exists = false;
  switch (type) {
    case "showbags":
      exists = myShowbags?.some((item) => item === slug);
      break;
    case "rides":
      exists = myRides?.some((item) => item === slug);
      break;
    case "events":
      exists = myEvents?.some((item) => item === slug);
      break;
    case "food_outlets":
      exists = myFood?.some((item) => item === slug);
      break;
    default:
      break;
  }

  if (!userId)
    return (
      <div onClick={() => setIsMyShowOpen(!isMyShowOpen)}>
        <PiHeartBold
          size={30}
          className={`text-button transition-transform duration-300 cursor-pointer`}
        />
      </div>
    );

  function toggleMyShow() {
    switch (type) {
      case "showbags":
        toast(<ToastMessage image={image} title={title} exists={exists} />);
        return myShowbags?.some((item) => item === slug)
          ? removeShowbag(slug, userId)
          : addShowbag(slug, userId);
      case "rides":
        toast(<ToastMessage image={image} title={title} exists={exists} />);
        return myRides?.some((item) => item === slug)
          ? removeRide(slug, userId)
          : addRide(slug, userId);
      case "events":
        toast(<ToastMessage image={image} title={title} exists={exists} />);
        return myEvents?.some((item) => item === slug)
          ? removeEvent(slug, userId)
          : addEvent(slug, userId);
      case "food_outlets":
        toast(<ToastMessage image={image} title={title} exists={exists} />);
        return myFood?.some((item) => item === slug)
          ? removeFood(slug, userId)
          : addFood(slug, userId);
      default:
        return;
    }
  }

  // Render
  return (
    <div onClick={() => toggleMyShow()}>
      {exists ? (
        <PiHeartFill
          size={30}
          className={`text-button transition-transform duration-300 cursor-pointer`}
        />
      ) : (
        <div className="relative">
          <PiHeartBold
            size={30}
            className={`transition-transform relative z-20 text-button duration-300 cursor-pointer`}
          />
          <PiHeartFill
            size={30}
            className={`text-white z-10 absolute inset-0 transition-transform duration-300 cursor-pointer`}
          />
        </div>
      )}
    </div>
  );
}

function ToastMessage({ image, title, exists }) {
  const { isMyShowOpen, setIsMyShowOpen } = useStore();
  return (
    <div
      onClick={() => setIsMyShowOpen(!isMyShowOpen)}
      className="flex w-full gap-4 cursor-pointer"
    >
      <div className="rounded-base">
        <div className="relative size-20">
          {image?.permalink ? (
            <Img
              className="w-full size-16 rounded-base"
              sizes="50px"
              fill
              data={image}
            />
          ) : (
            <Placeholder isLarge={false} type="image-placeholder" />
          )}
        </div>
      </div>
      <div className="flex flex-col justify-center">
        <p className="font-bold">{title}</p>
        <p>{exists ? "Removed from My Show" : "Added to My Show"}</p>
      </div>
    </div>
  );
}
